'use client';
import { useMemo } from 'react';
import cx from 'classnames';
import Link from './Link';
import styles from '../Footer.module.scss';
import { LinkBehaviour } from '../../../types/shared';
import type {
  SitemapProps,
  SitemapListProps,
  SitemapListItemProps,
} from '../../../types/types';

export const SitemapListItem = ({ link }: SitemapListItemProps) => {
  const { behaviour, text = '', url } = link ?? {};
  const nextLink = behaviour === LinkBehaviour.Standard;
  const target = behaviour === LinkBehaviour.Standard ? '_self' : '_blank';
  const rel =
    behaviour === LinkBehaviour.Standard ? '_self' : 'noopener noreferrer';
  return (
    <li>
      {url ? (
        <Link
          href={url}
          nextLink={nextLink}
          target={target}
          testId={`footer-${text}`}
          rel={rel}
        >
          {text}
        </Link>
      ) : (
        <span data-test-id={`footer-${text}`}>{text}</span>
      )}
    </li>
  );
};

export const SitemapList = ({
  text,
  links,
  isHeadingUppercase,
}: SitemapListProps) => {
  const title = useMemo(
    () => (isHeadingUppercase ? text.toLocaleUpperCase() : text),
    [isHeadingUppercase, text]
  );

  return (
    <ul className={styles.list}>
      <li>
        <h3
          data-test-id={`footer-header-${text}`}
          className={styles.listHeading}
        >
          {title}
        </h3>
      </li>
      {links?.map((link) => (
        <SitemapListItem key={link?.text} link={link} />
      ))}
    </ul>
  );
};

export const Sitemap = ({
  footerSitemapLinks,
  footerSitemapClass,
  isHeadingUppercase = true,
}: SitemapProps) => {
  const footerSitemapClasses = cx(styles.footerSitemap, footerSitemapClass);

  return (
    <div className={footerSitemapClasses} data-test-id='footer-sitemap'>
      {footerSitemapLinks?.map((link) => {
        const { text = '', children } = link ?? {};
        return (
          <SitemapList
            isHeadingUppercase={isHeadingUppercase}
            key={text}
            text={text}
            links={children}
          />
        );
      })}
    </div>
  );
};
